import React from 'react';
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink } from '@chakra-ui/react';
import { MdKeyboardArrowRight } from 'react-icons/md';
import PropTypes from 'prop-types';
import { LocalizedLink } from '@rsc/gatsby-localization-helpers';
import { useUiComponentsInternationalContext } from '@rsc/static-translations';

const generateBreadcrumbItems = (slugParts, custom, tt) =>
  slugParts
    ?.map(item => {
      // remove leading /'s
      if (item.pathname?.startsWith('/')) {
        // eslint-disable-next-line no-param-reassign
        item.pathname = item.pathname.slice(1);
      }
      if (item.title?.toLowerCase() === 'shop') {
        // eslint-disable-next-line no-param-reassign
        item.title = tt(s => s.breadcrumbComponent.shopBreadcrumbLabel);
      }
      return item;
    })
    .map((item, index) => {
      let href = !custom
        ? slugParts
            .slice(0, index + 1)
            .map(({ pathname }) => pathname)
            .join('/')
        : item.pathname;
      // This is here for if the first path is '/' (Home)
      if (!custom && href.startsWith('/')) href = href.slice(1);

      const isLast = index === slugParts.length - 1;
      return (
        <BreadcrumbItem key={item.title} isCurrentPage={isLast} mb="0">
          <BreadcrumbLink
            aria-label={item.title}
            as={!isLast && LocalizedLink}
            sx={{ textStyle: 'caption' }}
            to={`/${href}`}
            _hover={
              !isLast && {
                textDecoration: 'underline',
              }
            }
          >
            {item.title}
          </BreadcrumbLink>
        </BreadcrumbItem>
      );
    });

function PageBreadcrumb({ breadcrumbs, custom }) {
  const { tt } = useUiComponentsInternationalContext();
  return (
    <Breadcrumb
      separator={<MdKeyboardArrowRight />}
      spacing="5px"
      sx={{ '& > ol': { flexWrap: 'wrap', paddingLeft: 0 } }}
    >
      {generateBreadcrumbItems(breadcrumbs, custom, tt)}
    </Breadcrumb>
  );
}

export const BreadCrumbShape = PropTypes.shape({
  title: PropTypes.string,
  pathname: PropTypes.string,
});

PageBreadcrumb.propTypes = {
  breadcrumbs: PropTypes.arrayOf(BreadCrumbShape).isRequired,
  custom: PropTypes.bool,
};

PageBreadcrumb.defaultProps = {
  custom: false,
};

export default PageBreadcrumb;
